<template>
  <div class="checkout-white-depression">
    <img
      src="@/static/checkout-white/depression.png"
      alt="picture"
      class="checkout-white-depression__image"
    />
    <div class="checkout-white-depression__wrapper">
      <div class="checkout-white-depression__title">
        {{ title }}
      </div>
      <div class="checkout-white-depression__texts">
        <p
          v-for="(item, index) in texts"
          :key="index"
          class="checkout-white-depression__text"
          v-html="item.text"
        ></p>
      </div>
    </div>
    <div class="checkout-white-depression__arrow">
      <img
        src="@/static/checkout-white/icons/arrow.svg"
        alt="arrow"
        class="checkout-white-depression__arrow-icon"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title:
        'Struggling with anxiety? Feeling depressed and suffering from panic attacks? Having trouble sleeping? Procrastinating? Having a hard time overcoming a breakup? Feeling you are not financially stable?',
      texts: [
        {
          text: "Don't let mental issues ruin your personal and professional life. Take the first step towards CHANGE!",
        },
        {
          text: 'Every day, an average of 2000 people take their own lives, which is one person every 40 seconds. About 18.1% of the population suffers from anxiety and 6.2% - from mental illnesses.',
        },
        {
          text: "What's more important- over 45% of the working population says they suffer from increased stress levels!",
        },
        {
          text: 'Yes, all these data are part of OFFICIAL STATISTICS and are SHOCKING!',
        },
        {
          text: 'This is why our motivation is to offer a product on a natural basis, which not only dulls the symptoms of depression, panic attacks/anxiety, procrastination, insomnia, relationship traumas, lack of a goal-driven mindset but also effectively fights these conditions.',
        },
        {
          text: 'Imagine what it would feel like to have greater control over your mind and life. To know how to always feel calm, centered and focused. To be able to let go of things, overcome negative mental states and master the inner chatter. Be happy now, ACT NOW!',
        },
      ],
    }
  },
}
</script>

<style lang="scss">
.checkout-white-depression {
  position: relative;
  padding-top: 92px;

  &:after,
  &:before {
    content: '';
    position: absolute;
    top: 0;
    height: 100%;
    width: 339px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }

  &:after {
    left: -200px;
    background-image: url('~@/static/checkout-white/flower-left.svg');
  }

  &:before {
    right: -200px;
    background-image: url('~@/static/checkout-white/flower-right.svg');
  }

  &__image {
    position: relative;
    z-index: 1;
  }

  &__wrapper {
    position: relative;
    max-width: 925px;
    padding: 36px 60px 108px;
    margin-top: -240px;
    margin-inline: auto;
    background-color: var(--color-dark);
    border-radius: 8px;
    z-index: 2;
  }

  &__title {
    font-weight: 800;
    font-size: 36px;
    line-height: 49px;
    color: var(--color-yellow);
    padding-bottom: 36px;
  }

  &__text {
    font-weight: 400;
    font-size: 24px;
    line-height: 33px;
    color: var(--color-white);

    &:not(:last-child) {
      margin-bottom: 24px;
    }
  }

  &__arrow {
    position: absolute;
    bottom: -48px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 96px;
    height: 96px;
    border-radius: 50%;
    background-color: var(--color-red);
    z-index: 2;
  }
}
</style>
